document.addEventListener('DOMContentLoaded', function() {
    // Add form popup HTML
    document.body.insertAdjacentHTML('beforeend', `
        <div id="formPopup" style="display:none;">
            <div class="formPopup-overlay"></div>
            <div class="formPopup-content">
                <button class="formPopup-close">&times;</button>
                <div class="formPopup-body">
                    <div class="mktoContent mktoMobileShow">
                        <div class="lpeCElement">
                            <img src="https://761-PKF-687.mktoweb.com/rs/761-PKF-687/images/No-bg-logo.png" alt="No-bg-logo.png" class="formPopup-logo" />
                        </div>
                        <div class="lpeCElement">
                            <div class="formPopup-text">
                                Thank you for your interest in Elma Electronic! Please fill out the form below and someone will contact you shortly regarding your request.
                            </div>
                        </div>
                        <div class="lpeCElement Request-for-product">
                            <form class="mktoForm" id="mktoForm_1026"></form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <style>
            #formPopup {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 9999;
            }
            
            .formPopup-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                display:block;
            }
            
            .formPopup-content {
                position: relative;
                width: 90%;
                max-width: 1000px;
                max-height: 90vh;
                margin: 2vh auto;
                background: white;
                padding: 20px;
                border-radius: 4px;
                overflow-y: auto;
            }
            
            .formPopup-close {
                position: sticky;
                top: 0;
                right: 0px;
                float: right;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                z-index: 1;
            }
            
            .formPopup-logo {
                display: block;
                margin: 0;
                height: 54px;
                width: 142px;
            }
            
            .formPopup-text {
                text-align: left;
                margin: 20px 0;
                font-family: Helvetica, Arial, sans-serif;
                font-size: 14px;
            }
            
            .mktoForm {
                width: auto !important;
            }
            
            .mktoForm input[type="radio"] {
                display: inline-block !important;
                appearance: auto !important;
                -webkit-appearance: radio !important;
                -moz-appearance: radio !important;
                opacity: 1 !important;
                position: static !important;
                pointer-events: auto !important;
                width: 16px !important;
                height: 16px !important;
                margin: 3px 5px 0 0 !important;
                clip: auto !important;
                visibility: visible !important;
                border: 1px solid #ccc !important;
                background-color: white !important;
            }
            
            .mktoForm div {
                margin-left: 10px;
            }
            
            .mktoRadioList input[type="radio"] {
                display: inline-block !important;
                opacity: 1 !important;
                visibility: visible !important;
            }

            /* Responsive Styles */

            @media (max-width: 1115px) {
             .mktoForm div {
                  margin-left: 0px;
              }
            }
            
            @media (max-width: 768px) {
                .formPopup-content {
                    width: 95%;
                    margin: 5vh auto;
                }

                .formPopup-logo {
                    width: 120px;
                    height: auto;
                }

                .formPopup-text {
                    font-size: 13px;
                }

                .mktoForm div {
                  margin-left: 0px;
              }
            }

            @media (max-width: 480px) {
                .formPopup-content {
                    padding: 15px;
                }

                .formPopup-text {
                    font-size: 12px;
                }
            }
        </style>
    `);

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    document.querySelector('.productView-requestInformation-button').addEventListener('click', async function(e) {
        e.preventDefault();
        
        try {
            if (typeof MktoForms2 === 'undefined') {
                await loadScript('//go3.elma.com/js/forms2/js/forms2.min.js');
            }
            
            if (typeof Munchkin === 'undefined') {
                await loadScript('//munchkin.marketo.net/munchkin.js');
                Munchkin.init('761-PKF-687');
            }
            
            MktoForms2.loadForm("//go3.elma.com", "761-PKF-687", 1026, function(form) {
                form.onSuccess(function(values, followUpUrl) {
                    const formEl = form.getFormElem();
                    document.querySelector('.formPopup-text').style.display = 'none';
                    formEl.html('<div class="formSuccess-message" style="text-align:center; padding:20px;"><h3>Thank you for your submission!</h3><p>Someone will contact you shortly.</p></div>');
                    document.querySelector('.formSuccess-message').style.display = 'block';
                    return false;
                });
            });
            
            document.getElementById('formPopup').style.display = 'block';
        } catch (error) {
            console.error('Error loading form:', error);
             document.querySelector('.productView-requestInformation-button-simulator').click();
        }
    });

    document.querySelector('.formPopup-close').addEventListener('click', function() {
        document.getElementById('formPopup').style.display = 'none';
        document.querySelector('.formPopup-text').style.display = 'block';
        document.querySelector('.formSuccess-message').style.display = 'none';
    });
});
